import { useBrowseEnrichmentApi } from '@aibees/elephant/api/enrichment/use-browse-enrichment-api';
import { baseQueryClient } from '@aibees/shared/http';
import { SocketMessageType, useSocketEvent } from '@aibees/shared/socket';
import { useGetSocketChannel } from '@aibees/shared/socket/hooks/use-get-socket-channel';
import { debounce } from 'lodash-es';
import { useRef } from 'react';
import { ExportsChangesSocketMessage } from './types';
import { useBrowseSearchExports } from './use-browse-search-exports';

export function useSocketExportChanges() {
  const channel = useGetSocketChannel(SocketMessageType.EXPORT_ADD);

  const debouncedInvalidate = useRef(
    debounce(() => {
      baseQueryClient.invalidateQueries([useBrowseSearchExports.name]);
      baseQueryClient.invalidateQueries([useBrowseEnrichmentApi.name]);
    }, 500)
  ).current;

  useSocketEvent(channel, (data: ExportsChangesSocketMessage) => {
    if (
      data.type === SocketMessageType.EXPORT_ADD ||
      data.type === SocketMessageType.EXPORT_UPDATE ||
      data.type === SocketMessageType.EXPORT_INTEGRATION_UPDATE
    ) {
      debouncedInvalidate();
    }
  });
}
